import { rd } from '@passionware/monads';
import { useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { Dialog, DialogContentHeadless } from '../../design-system/Dialog';
import { WithServices } from '../../platform/ts/services';
import { WithFeatureManagementService } from '../../services/front/FeatureManagementService/FeatureManagementService';
import { FeatureFlagView } from './FeatureFlagView';
import { UnsavedChangesProtection } from 'v5/patterns/forms/unsaved-changes/UnsavedChangesProtection';
import { myAccessService } from 'v5/services/front/AccessService/AccessService.connected';

export function FeatureFlagWidget(
  props: WithServices<[WithFeatureManagementService]>
) {
  const [show, setShow] = useState(false);
  const can = myAccessService.useCan();
  const canManageFeatureFlags = rd.tryGet(
    can({ action: 'manage_feature_flags' })
  );

  useHotkeys('ctrl+shift+l', () => {
    if (canManageFeatureFlags) {
      setShow(prev => !prev);
    }
  });

  const { featureManagementService } = props.services;
  const view = featureManagementService.useFeatureFlagConfigView();
  const [tab, setTab] = useState<string>('');
  rd.useDataEffect(view, state => {
    if (tab === '') {
      setTab(state.featureFlagView.groups[0].name);
    }
  });

  return (
    <UnsavedChangesProtection
      isDirty={rd.tryGet(view)?.isDirty}
      open={show}
      onOpenChange={setShow}
    >
      {dialogProps => (
        <Dialog {...dialogProps}>
          <DialogContentHeadless>
            <FeatureFlagView
              tab={tab}
              onTabChange={setTab}
              view={view}
              onAction={featureManagementService.scheduleAction}
              onSave={() =>
                featureManagementService.saveConfig().then(() => setShow(false))
              }
            />
          </DialogContentHeadless>
        </Dialog>
      )}
    </UnsavedChangesProtection>
  );
}
